import styled from 'styled-components/macro';

const ShapesContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 1000px;
  width: 80%;
`;

export default ShapesContainer;
